<template lang="html">
  <div>
    <img src="~./01@2x.png" width="100%" />
    <img src="~./02@2x.png" width="100%" />
    <img src="~./03@2x.png" width="100%" />
    <img src="~./04@2x.png" width="100%" />
    <img src="~./05@2x.png" width="100%" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
